import apiClient from './apiClient';

const verificationRequests = new Map();

export const verifyEmailToken = (token) => {
  if (!verificationRequests.has(token)) {
    const request = apiClient
      .get('/auth/verify-email', {
        params: { token },
      })
      .then((response) => response.data);

    verificationRequests.set(token, request);
  }

  return verificationRequests.get(token);
};
